var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.99,
    height: 47.99,
    rx: 8,
    fill: "#F3E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9871 33.9917C20.5393 33.9917 20.9871 33.544 20.9871 32.9917C20.9871 32.4394 20.5393 31.9917 19.9871 31.9917C19.4348 31.9917 18.9871 32.4394 18.9871 32.9917C18.9871 33.544 19.4348 33.9917 19.9871 33.9917Z",
    stroke: "#9333EA",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9824 33.9917C31.5347 33.9917 31.9824 33.544 31.9824 32.9917C31.9824 32.4394 31.5347 31.9917 30.9824 31.9917C30.4301 31.9917 29.9824 32.4394 29.9824 32.9917C29.9824 33.544 30.4301 33.9917 30.9824 33.9917Z",
    stroke: "#9333EA",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0391 14.0491H16.0382L18.6971 26.4639C18.7947 26.9186 19.0476 27.325 19.4125 27.6133C19.7774 27.9015 20.2314 28.0536 20.6963 28.0432H30.4722C30.9272 28.0425 31.3683 27.8866 31.7227 27.6013C32.0771 27.3159 32.3236 26.9182 32.4214 26.4739L34.0707 19.047H17.1078",
    stroke: "#9333EA",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarts);
export default __webpack_public_path__ + "static/media/carts.cf907e5b2f29bf986e33013bc308017b.svg";
export { ForwardRef as ReactComponent };